import { Link } from 'react-router-dom';
import AccountLayout from './LoginLayout';
import mailSent from 'assets/images/mail_sent.svg';
import { useAppSelector } from 'redux/hooks';
import { RootState } from 'redux/store';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Confirm = () => {
    const navigate = useNavigate();
    const email = useAppSelector((state: RootState) => state.login.email);

    useEffect(() => {
        if (email === "") {
            navigate("/forgot-password");
        }
    }, [email]);

    return (
        <AccountLayout>
            <div className="text-center m-auto">
                <img src={mailSent} alt="mail sent" height="64" />
                <h4 className="text-dark-50 text-center mt-4 font-weight-bold">Please check your email</h4>
                <p className="text-muted mb-4">An email has been sent to <b>{email}</b>. Please check for an email from Z Software and click on the included link to reset your password. 
                </p>
                <p className="text-center">
                    <Link className="btn btn-primary" to="/login">Back to Login</Link>
                </p>
            </div>
        </AccountLayout>
    );
};

export default Confirm;
